// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark theme styles */
.central-controls-bar {
  display: flex;
  align-items: center;
  background-color: #333;
  color: white;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  justify-content: space-between;
}

.controls-left {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 5px;
}

.controls-left .left-controls-group {
  display: flex;
  align-items: center;
  gap: 5px;
}

.controls-right {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 8px;
}

.controls-central {
  flex-grow: 1; /* Makes this container take up the remaining space */
  display: flex;
  flex-direction: column;
  padding: 0px;
}

textarea {
  background-color: #444;
  color: white;
  padding: 0px;
  border-radius: 5px;
  border: 1px solid #555;
  resize:"none";
  width: 100%;
  height: 100%; /* This will make the textarea fill the space */
}

input {
  background-color: #444;
  color: white;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #555;
}

button {
  background-color: #444;
  color: white;
  border: 1px solid #555;
  padding: 4px 4px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

button:disabled {
  background-color: #555;
  cursor: not-allowed;
}

button:hover {
  background-color: #666;
}

select {
  background-color: #444;
  color: white;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #555;
}

.icon-container {
  display: flex;
  gap: 5px;
}

.icon-button {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.icon-button img {
  width: 24px;
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Central/CentralControlsBar1.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY,EAAE,qDAAqD;EACnE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Dark theme styles */\n.central-controls-bar {\n  display: flex;\n  align-items: center;\n  background-color: #333;\n  color: white;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border-radius: 8px;\n  justify-content: space-between;\n}\n\n.controls-left {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 5px;\n}\n\n.controls-left .left-controls-group {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.controls-right {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.controls-central {\n  flex-grow: 1; /* Makes this container take up the remaining space */\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n}\n\ntextarea {\n  background-color: #444;\n  color: white;\n  padding: 0px;\n  border-radius: 5px;\n  border: 1px solid #555;\n  resize:\"none\";\n  width: 100%;\n  height: 100%; /* This will make the textarea fill the space */\n}\n\ninput {\n  background-color: #444;\n  color: white;\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #555;\n}\n\nbutton {\n  background-color: #444;\n  color: white;\n  border: 1px solid #555;\n  padding: 4px 4px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\nbutton:disabled {\n  background-color: #555;\n  cursor: not-allowed;\n}\n\nbutton:hover {\n  background-color: #666;\n}\n\nselect {\n  background-color: #444;\n  color: white;\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #555;\n}\n\n.icon-container {\n  display: flex;\n  gap: 5px;\n}\n\n.icon-button {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.icon-button img {\n  width: 24px;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
